import { render } from "./MessageIn.vue?vue&type=template&id=22819606"
import script from "./MessageIn.vue?vue&type=script&lang=ts"
export * from "./MessageIn.vue?vue&type=script&lang=ts"
script.render = render

export default script